import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";

import FormPersonalData from "./personal-data";
import FormAddress from "./address";
import FormBankDetails from "./bank-details";
import TabsNavigate from "../../../../components/TabsNavigate";
import FormProfessionalData from "./professional-data";
import FormSpecificData from "./data-specific";

import { ModalMessage } from "../../../../components/ModalMessage";
import "./index.scss";
import { FormStoreProvider } from "./store";
import useFormStore from "./store/useStore";
import useAppData from "../../../../hook/useAppData";
import { serviceUsers } from "../../service";
import { _formatDate } from "../../../../libs/dateUtils";
import { toastError } from "../../../../components/Toast";
import { Toaster } from "react-hot-toast";
import { replaceNumberToString } from "./professional-data/libs";
import { unRemask } from "../../../../libs/remask-mask";
import FormProjectsData from "./projects-data";
import { isEmailValid } from "../../../../libs/validation-email";
import { postNewPassword } from "../../../../page/auth/service/service";
import { ACCESS } from "../../../Profile/constants";

export const PersonEntity = {
  1: "PF",
  2: "PJ",
  PF: 1,
  PJ: 2,
};

export default function Collaborators(props: any) {
  const params = Object.keys(props)[0] === "userId" ? props?.userId : props?.match?.params.id;
  return (
    <FormStoreProvider params={params}>
      <CollaboratorsComponent params={params} />
    </FormStoreProvider>
  );
}

function CollaboratorsComponent(params: any) {
  const [needModalMessage, setNeedModalMessage] = useState({
    status: false,
    id: 0,
  });
  const [needModalMessageSchedule, setNeedModalMessageSchedule] = useState(false);

  const [objValue, setObjValue] = useState<any>();

  const { profileId, token, accessIds } = useAppData();
  const {
    updateValue,
    contract_type,
    selectedTech,
    selectedCostCenter,
    selectedJob_roles,
    state,
    resultCalcPreview,
    saveOrSchedule,
    setSaveOrSchedule,
    dateSchedule,
    isSchedule,
    setIsSchedule,
    tax,
  } = useFormStore();
  const history = useHistory();

  const idUrl: string = isUrlSchedule(params);
  const idUrlOriginal: string = params.params;

  useEffect(() => {
    if (idUrlOriginal?.includes("schedule=")) handleSchuleModo();
  }, []);

  const tabs = ["Dados Pessoais", "Endereço", "Dados Bancarios", "Dados Profissionais", "Custos", "Projetos"];
  const tabs2 = ["Dados Pessoais", "Endereço", "Dados Bancarios"];
  const tabs3 = ["Dados Pessoais", "Endereço", "Dados Bancarios", "Dados da Empresa"];

  function handleSchuleModo() {
    setSaveOrSchedule("schedule");
  }

  function isUrlSchedule(props) {
    const params = props?.params;
    if (params?.includes("schedule=")) return params?.replace("schedule=", "");
    return params;
  }

  function handleConfirmClick() {
    if (accessIds?.includes(ACCESS?.USERS_DATA_all)) return history.push("/collaborator");
    return history.push("/home");
  }

  function verifyProfile() {
    if (Number(updateValue.profile) === 0) return true;
    return false;
  }

  function verifyNameEmpty() {
    if (updateValue.name.replaceAll(" ", "").length === 0) return true;
    return false;
  }

  function verifyContractType() {
    if (Number(contract_type) === 0) return true;
    return false;
  }

  function verifyValueContractType() {
    if (Number(contract_type) === 1) return "CLT";
    if (Number(contract_type) === 2) return "PJ";
  }

  function verefyExtensionEmailValid() {
    const email = updateValue.email;
    return !isEmailValid(email);
  }

  function handleClick() {
    if (verifyNameEmpty()) return toastError("Nome não definido");
    if (verefyExtensionEmailValid()) return toastError("Erro no cadastro, email com extensão inválida!");
    if (verifyContractType()) return toastError("Regime de Contratação não definido");
    if (verifyProfile()) return toastError("Perfil Profissional não definido");

    const objAddress = {
      ...updateValue?.address,
      zip_code: unRemask(String(updateValue?.address?.zip_code)),
      number: Number(updateValue?.address?.number),
    };

    const objBank = {
      ...updateValue?.bank_data,
      account: unRemask(updateValue?.bank_data?.account),
      person_entity: PersonEntity[+updateValue?.bank_data?.person_entity],
    };

    const objProfissional = {
      beginnig_at: convertDateIfNotNull(updateValue?.data_professional?.beginnig_at),
      hourly_pay: verefyHourlyPay(updateValue),
      monthly_pay: verefyMounthlyPay(updateValue),
      type_tax_id: getTaxValueInDTO(updateValue, tax)?.idField,
      type_tax_simple: getTaxValueInDTO(updateValue, tax)?.simple,
    };

    const objCostCollaborator = {
      ...updateValue?.collaborator_cost,
      total: resultCalcPreview?.total,
      cost_unity: resultCalcPreview?.cost_unity,
      cnpj: unRemask(updateValue?.collaborator_cost?.cnpj),
    };

    const objPersonal = {
      ...updateValue,
      CPF: unRemask(updateValue?.CPF),
      RG: unRemask(updateValue?.RG),
      phone: unRemask(updateValue?.phone),
      phone_two: unRemask(String(updateValue?.phone_two)),
      birth_date: convertDateIfNotNull(updateValue?.birth_date),
      address: objAddress,
      data_professional: objProfissional,
      bank_data: objBank,
      seniority: Number(updateValue?.seniority),
      contract_type: verifyValueContractType(),
      technology: selectedTech,
      hourBase: Number(updateValue?.hourBase),
      cost_center: selectedCostCenter,
      job_role: selectedJob_roles,
      profile: +updateValue?.profile,
      pay_config: updateValue.pay_config == "1" ? "MOUNTH" : "HOURS",
      is_deleted: state,
      isDeleted: state,
      collaborator_cost: objCostCollaborator,
      end_date: convertDateIfNotNull(updateValue?.end_date),
      isBilled: updateValue.isBilled,
    };
    setObjValue(objPersonal);
    saveUserApi(objPersonal);
  }

  async function saveUserApi(objPersonal) {
    if (saveOrSchedule == "save") {
      if (idUrl === undefined) {
        serviceUsers.postUsers(objPersonal, token).then((res) => {
          redirectSuccessApi(res, objPersonal?.email);
          if (res?.status === 409) return toastError("Algum campo já cadastrado, verifique e tente novamente!");
          else toastError("Erro no cadastro, verifique e tente novamente!");
        });
      }
      if (idUrl !== undefined) {
        if (!isSchedule) {
          return serviceUsers.putUsers(objPersonal, idUrl, token).then((res) => {
            redirectSuccessApi(res);
          });
        }
        setNeedModalMessageSchedule(true);
      }
    } else {
      if (!dateSchedule) return toastError("Data de agendamento é obrigatório!");
      const obj = {
        userId: idUrl,
        date: dateSchedule,
        json: { ...objPersonal },
      };
      if (isSchedule) {
        const res = await serviceUsers.putUserSchedule({ id: obj.userId, token, dadosBody: obj });
        redirectSuccessApi(res);
        if (!res?.ok) toastError("Erro na edição, verifique e tente novamente!");
      } else {
        const res = await serviceUsers.postUserSchedule(token, obj);
        redirectSuccessApi(res);
        if (!res?.ok) toastError("Erro na edição, verifique e tente novamente!");
      }
    }
  }

  function redirectSuccessApi(res, email?: string) {
    if (!res?.ok) return;
    if (email) {
      const data = {
        email,
      };
      postNewPassword(data);
    }
    if (accessIds?.includes(ACCESS.USERS_DATA_all)) return history.push("/collaborator");
    return history.push("/home");
  }

  function tabsController() {
    if (accessIds.includes(ACCESS.USERS_DATA_all)) return tabs;
    if (!accessIds?.includes(ACCESS.USERS_DATA_all) && Number(contract_type) !== 1) return tabs3;
    else return tabs2;
  }

  async function saveAndDelete() {
    await serviceUsers.deleteUsersSchedule(isSchedule, token);
    setIsSchedule(0);
    setNeedModalMessageSchedule(false);
    await serviceUsers.putUsers(objValue, idUrl, token).then((res) => {
      redirectSuccessApi(res);
    });
  }

  function handleSchedule() {
    setSaveOrSchedule("schedule");
    setNeedModalMessageSchedule(false);
  }

  return (
    <>
      <Toaster />
      <div className="collaboratorsContainer container">
        <ModalMessage
          status={needModalMessage.status}
          id={needModalMessage.id}
          onClickCancel={setNeedModalMessage}
          onClickConfirm={handleConfirmClick}
          text="Você tem certeza disso?"
        />

        <ModalMessageSchedule
          status={needModalMessageSchedule}
          onClickCancel={saveAndDelete}
          onClickConfirm={handleSchedule}
          text="Existe um agendamento para esse usuário! "
        />

        <TabsNavigate tabs={tabsController()}>
          <FormPersonalData profileId={profileId} />
          <FormAddress />
          <FormBankDetails />
          {!accessIds.includes(ACCESS.USERS_DATA_all) ? Number(contract_type) === 2 && <FormSpecificData /> : <FormProfessionalData />}
          {accessIds.includes(ACCESS.USERS_DATA_all) && <FormSpecificData profile={profileId} contract={contract_type} />}
          {accessIds.includes(ACCESS.USERS_DATA_all) && <FormProjectsData id={idUrl} />}
        </TabsNavigate>
        <div className="btn-container">
          <button className="btn bg-secondary" type="button" onClick={() => setNeedModalMessage({ status: true, id: 0 })}>
            Cancelar
          </button>

          <button className="btn bg-primary" onClick={handleClick} type="button">
            {saveOrSchedule == "schedule" ? " Agendar" : "Salvar"}
          </button>
        </div>
      </div>
    </>
  );
}

function convertDateIfNotNull(date: string) {
  if (!date) return "";
  return date;
}

function verefyHourlyPay(updateValue: any) {
  if (updateValue.pay_config == 1) {
    if (
      String(updateValue.data_professional.hourly_pay) === "" ||
      String(updateValue.data_professional.hourly_pay) !== String(Number(replaceNumberToString(updateValue.data_professional.monthly_pay)) / 168)
    ) {
      if (String(updateValue.data_professional.monthly_pay) !== "" && String(updateValue.data_professional.monthly_pay) !== "null") {
        return String(Number(replaceNumberToString(updateValue.data_professional.monthly_pay)) / 168);
      } else return String(updateValue.data_professional.hourly_pay);
    }
  }
  return String(updateValue.data_professional.hourly_pay);
}

function verefyMounthlyPay(updateValue: any) {
  if (updateValue.pay_config == 2) {
    if (
      String(updateValue.data_professional.monthly_pay) === "" ||
      String(updateValue.data_professional.monthly_pay) !== String(Number(replaceNumberToString(updateValue.data_professional.hourly_pay)) * 168)
    ) {
      if (String(updateValue.data_professional.hourly_pay) !== "" && String(updateValue.data_professional.hourly_pay) !== "null") {
        return String(Number(replaceNumberToString(updateValue.data_professional.hourly_pay)) * 168);
      }
      return String(updateValue.data_professional.monthly_pay);
    }
  }
  return String(updateValue.data_professional.monthly_pay);
}

interface ModalDeleteProps {
  id?: number;
  status: boolean;
  text: string;
  email?: string;
  onClickCancel: (event?: any) => void;
  onClickConfirm: (event?: any) => void;
}

function ModalMessageSchedule({ status, text, onClickCancel, onClickConfirm }: ModalDeleteProps) {
  return (
    <>
      {status && (
        <div className="modal-container schedule">
          <div className="modalDeleteContainer">
            <h1>{text}</h1>
            <div className="modalDeleteContainerButton">
              <button className="btn" type="button" onClick={() => onClickCancel()}>
                Salvar assim e apagar agendamento?
              </button>
              <button
                className="btn"
                type="button"
                onClick={() => {
                  onClickConfirm();
                }}
              >
                Atualizar o agendamento
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export function getTaxValueInDTO(updateValue, tax): { idField: number; simple: boolean } {
  if (!tax?.length) return;
  const idTax = updateValue?.data_professional?.type_tax_id;
  const value = tax?.find((valueTax) => valueTax?.id === idTax);
  return value;
}
